import axios, { type AxiosInstance, type CancelTokenSource, type InternalAxiosRequestConfig } from "axios";

// Store
import { store } from "src/store";

// Actions
import { invalidToken as logout } from "src/store/auth/reducer";

interface CancelableAxiosRequestConfig extends InternalAxiosRequestConfig {
  source?: CancelTokenSource;
}

export let api: AxiosInstance;

export const configureApi = (options = {}) => {
  const baseURL = import.meta.env.VITE_API_URL;
  const reqInProgress: CancelableAxiosRequestConfig[] = [];
  const exceptions: Array<string | undefined> = ["/api/auth/token/"];

  if (api === undefined) {
    api = axios.create({
      baseURL,
      ...options,
    });

    api.interceptors.request.use(
      async (config: CancelableAxiosRequestConfig) => {
        const { auth } = store.getState();

        // Add starttime
        (config as any).metadata = { startTime: new Date() };

        if (!exceptions.includes(config.url)) {
          const cancelToken = axios.CancelToken.source();
          config.cancelToken = cancelToken.token;
          config.source = cancelToken;

          let i;

          const foundReq = reqInProgress.find((req, index) => {
            if (config.url === req.url && config.method === req.method) {
              i = index;
              return true;
            }

            return false;
          });

          // If are other pending, cancel
          if (foundReq) {
            foundReq.source?.cancel();

            if (i !== undefined) reqInProgress.splice(i, 1);
          }

          reqInProgress.push(config);

          if (auth.accessToken) config.headers.Authorization = auth.accessToken;
        }

        return config;
      },

      (error) => Promise.reject(error),
    );

    api.interceptors.response.use(
      (response) => {
        if (!exceptions.includes(response.config.url)) {
          let i;
          const foundReq = reqInProgress.find((req, index) => {
            if (response.config.url === req.url && response.config.method === req.method) {
              i = index;
              return true;
            }

            return false;
          });

          if (foundReq && i !== undefined) reqInProgress.splice(i, 1);
        }

        return response;
      },
      (error) => {
        if (axios.isCancel(error)) {
          return Promise.resolve({
            status: 301,
            error: { message: "Requisição cancelada" },
          });
        }

        if (error.response.status === 401) {
          store.dispatch(logout());

          return Promise.reject(error);
        }

        return Promise.reject(error);
      },
    );
  }

  return api;
};
